import { DeepPartial } from 'ts-essentials';
import { ILayoutModel } from '@src/slide/domain/ui-model/element-modeles/Interface/layout-model.interface';
import { ILayoutData, ILayoutProps } from '@tencent/slide-sdk-model';

export class LayoutPropertyConverter {
    /**
     * 数据3.0转换接口
     * @param sdkData
     * @param uiData
     */
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepPartial<ILayoutProps>,
        uiData: ILayoutModel,
    ): void {
        if (sdkData.masterId !== undefined) {
            uiData.masterId = sdkData.masterId;
        }
        if (sdkData.cSld?.name !== undefined) {
            uiData.name = sdkData.cSld.name;
        }
        if (sdkData.layoutType !== undefined) {
            uiData.layoutType = sdkData.layoutType;
        }
    }

    public static convertPartialDataFromUiToSdk(
        uiData: DeepPartial<ILayoutModel>,
        sdkData: ILayoutData,
    ): void {

    }
}
